// NS1 — Content Depth Strip. Scrolling marquee on teal background.
// Shows the 10 current LearnixTa paths, always up to date with site naming.
import React from 'react';

const PATH_ITEMS = [
  'Career Clarity Tests · After 10th / Inter',
  'Inner Specializations · B.Tech · BBA · MBA',
  'Future-Ready Job Roles',
  'AI Pathway',
  'Banking Careers',
  'Blue-Collar Jobs',
  'Entrepreneurship · OwnPath',
  'Build Badges',
  'Is AI Coming for Your Role?',
  'Life Skills — For Every Future',
];

const Row = ({ items }) => (
  <>
    {items.map((t, i) => (
      <span key={i} className="inline-flex items-center shrink-0">
        <span>{t}</span>
        <span aria-hidden className="mx-5 md:mx-7 opacity-60">·</span>
      </span>
    ))}
  </>
);

const ContentDepthStrip = () => {
  return (
    <section
      className="text-white font-medium overflow-hidden border-y border-white/10"
      style={{ background: '#1D9E75' }}
      data-testid="content-depth-strip"
    >
      <div className="py-3.5 md:py-4 group">
        <div
          className="flex whitespace-nowrap text-xs md:text-sm"
          style={{ animation: 'cds-scroll 40s linear infinite' }}
        >
          {/* Two copies for seamless loop */}
          <div className="flex shrink-0 pr-5"><Row items={PATH_ITEMS} /></div>
          <div className="flex shrink-0 pr-5" aria-hidden><Row items={PATH_ITEMS} /></div>
        </div>
      </div>

      <style>{`
        @keyframes cds-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .group:hover [style*="cds-scroll"] { animation-play-state: paused; }
      `}</style>
    </section>
  );
};

export default ContentDepthStrip;
